import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from "firebase/storage";
import { initializeAppCheck, ReCaptchaEnterpriseProvider } from "firebase/app-check";

const firebaseConfig =
{
  apiKey: "AIzaSyCJcHOdACBICV-z5cjkGrCJMCnMZVViCNw",
  authDomain: "eduforces-493.firebaseapp.com",
  projectId: "eduforces-493",
  storageBucket: "eduforces-493.firebasestorage.app",
  messagingSenderId: "547268344133",
  appId: "1:547268344133:web:84a5f4706869268425662c",
  measurementId: "G-G12XPTYKDT"
};

const app = initializeApp(firebaseConfig);

const appCheck = initializeAppCheck(app, {
  provider: new ReCaptchaEnterpriseProvider(
    "6Le5F4EtAAAAAGkA4F-LiNez1PBZlwZ05REpGEXS"
  ),
  isTokenAutoRefreshEnabled: true
});

export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
